import paymentTransactionList from "../../slices/payment_history/PaymentTransactionList";
import paymentTransactionDetails from "../../slices/payment_history/PaymentTransactionDetails";
import paymentTransactionInvoice from "../../slices/payment_history/PaymentTransactionInvoice";

const paymentHistoryReducer = {
    paymentTransactionList,
    paymentTransactionDetails,
    paymentTransactionInvoice,
};

export default paymentHistoryReducer;
